import _ from 'lodash'

import { Path } from '../lib/Path'
import { docC } from 'src/globals'
import * as Model from 'src/types/document'

export type Stack = Array<StackFrame>
export type StackFrame = EditorStackFrame | CallStackFrame | ListOpStackFrame | RunOnNodeStackFrame | {type: 'scratch'}
export interface EditorStackFrame {type: 'editor', definitionP: Path}
export interface CallStackFrame {type: 'call', callP: Path}
export interface ListOpStackFrame {type: 'list-op', callP: Path, index: number | string}
export interface RunOnNodeStackFrame {type: 'run-on-node', definitionP: Path, nodeId: Model.NodeId}

export const EditorStackFrame = {
  definitionC(frame: EditorStackFrame) { return docC<Model.Definition>(frame.definitionP) },
}

export const CallStackFrame = {
  callC(frame: CallStackFrame) { return docC<Model.DefinitionCall>(frame.callP) },
}

export const ListOpStackFrame = {
  callC(frame: ListOpStackFrame) { return docC<Model.ListOpCall>(frame.callP) },
}

export const RunOnNodeStackFrame = {
  definitionC(frame: RunOnNodeStackFrame) { return docC<Model.Definition>(frame.definitionP) },
}

export function stackBottom(stack: Stack): StackFrame {
  return stack[stack.length - 1]  // stacks are assumed to always be nonempty
}

export function stacksAreEqual(stack1: Stack, stack2: Stack): boolean {
  return _.isEqual(stack1, stack2)
}

export function canDragFromStackIntoStack(stack1: Stack, stack2: Stack): boolean {
  if (stacksAreEqual(stack1, stack2)) {
    return true
  } else if (stackBottom(stack2).type === 'list-op') {
    return canDragFromStackIntoStack(stack1, _.initial(stack2))
  } else {
    return false
  }
}


// WEBPACK FOOTER //
// ./src/types/stack.ts